import { get } from 'lodash';
import {
  getData,
  getLengthOfReceivingIncome,
  getNumericData,
  getPhoneNumber
} from 'helpers/GetInitialData';

const isSpouseAddressSame =
  getData('registration[is_spouse_address_same]') === 'true' || '';

const initialState = {
  firstName: getData('registration[first_name]') || '',
  lastName: getData('registration[last_name]') || '',
  isReferral: getData('registration[is_referral]') || '',
  primaryPhoneNumber:
    getPhoneNumber(getData('registration[mobile_phone]')?.replace(/\D/g, '')) ||
    '',
  secondaryPhoneNumber:
    getPhoneNumber(getData('registration[home_phone]')?.replace(/\D/g, '')) ||
    '',
  loanPurpose: getData('registration[loan_purpose]') || '',
  addressEntryMetadata: {},
  homeStreetAddress: getData('registration[street_address]') || '',
  secondaryAddress: getData('registration[secondary_address]') || '',
  city: getData('registration[location][city]') || '',
  state: getData('registration[location][state]') || '',
  zip: getData('registration[location][zip]') || '',
  dateOfBirth: getData('registration[date_of_birth]')?.replace(/\D/g, '') || '',
  isMarried: getData('registration[is_married]') || '',
  spouseFirstName: getData('registration[spouse_first_name]') || '',
  spouseLastName: getData('registration[spouse_last_name]') || '',
  isSpouseAddressSame,
  spouseAddress:
    (isSpouseAddressSame
      ? getData('registration[street_address]')
      : getData('registration[spouse_street_address]')) || '',
  spouseCity:
    (isSpouseAddressSame
      ? getData('registration[location][city]')
      : getData('registration[spouse_location][city]')) || '',
  spouseState:
    (isSpouseAddressSame
      ? getData('registration[location][state]')
      : getData('registration[spouse_location][state]')) || '',
  spouseZip:
    (isSpouseAddressSame
      ? getData('registration[location][zip]')
      : getData('registration[spouse_location][zip]')) || '',
  socialSecurityNumber:
    getNumericData('registration[social_security_number]') || '',
  confirmSocialSecurityNumber:
    getNumericData('registration[social_security_number]') || '',
  grossMonthlyIncome: getData('registration[gross_monthly_income]') || '',
  primaryIncomeSource: getData('registration[income_type]') || '',
  occupation: getData('registration[occupation]') || '',
  nameOfIncome: getData('registration[employer_name]') || '',
  lengthOfReceivingIncome: getLengthOfReceivingIncome() || '',
  paymentFrequency: getData('registration[payroll_frequency]') || '',
  lastPayrollDate:
    (getData('registration[last_payroll_date]') || '').replace(/ /g, '') ||
    null,
  nextPayrollDate:
    (getData('registration[next_payroll_date]') || '').replace(/ /g, '') ||
    null,
  accountType: getData('registration[account_type]') || '',
  routingNumber: '',
  bankName: '',
  accountNumber: '',
  confirmAccountNumber: '',
  bankAccountAge: getData('registration[account_length][months]') || '',
  loanAmount: getData('registration[loan_amount]') || '',
  minLoanAmount: '500',
  maxLoanAmount: '5000',
  email: getData('registration[email_address]') || '',
  password: '',
  paymentType: getData('registration[payroll_type]'),
  employmentStatus: getData('registration[currently_employed]') || '',
  productOwner:
    get(window, ['AppConfig', 'cl_application', 'product_owner']) ||
    get(window, [
      'AppConfig',
      'partner',
      'partner_event_data',
      'originating_org'
    ]) ||
    'opploans',
  billingNotificationsDisclosure: false,
  marketingDisclosure: false,
  elecCommDisclosure: false,
  bankNameVisible: false,
  bankNameDisabled: false,
  errors: {},
  isDisabled: {
    spouseAddress: isSpouseAddressSame ? true : null,
    spouseCity: isSpouseAddressSame ? true : null,
    spouseState: isSpouseAddressSame ? true : null,
    spouseZip: isSpouseAddressSame ? true : null
  },
  visibilityRules: {},
  additionalProps: {}
};

function getInitialState() {
  return initialState;
}

export default getInitialState;
